// eslint-disable-next-line @typescript-eslint/no-unused-vars
import {createSlice, PayloadAction} from '@reduxjs/toolkit';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import type {RootState} from '../store';


// Define a type for the slice state
interface NotificationsState {
    snackbar: {message: string; type: string; body?: string;}[];
}

// Define the initial state using that type
const initialState: NotificationsState = {
    snackbar: [],
} as NotificationsState;

export const notificationsSlice = createSlice({
    name: 'notifications',
    // `createSlice` will infer the state type from the `initialState` argument
    initialState,
    reducers: {
        notifyError: (state, action: PayloadAction<string>) => {
            state.snackbar.push({type: 'error', message: action.payload})
        },
        discardFirstNotification: (state) => {
            state.snackbar = state.snackbar.slice(1)
        }
    },
});

export const {notifyError, discardFirstNotification} = notificationsSlice.actions;

export default notificationsSlice.reducer;
